export const ACCOUNT_TYPE = {
  STUDENT: "Student",
  INSTRUCTOR: "Instructor",
  ADMIN: "Admin", // optional if you plan for admins
};

export const COURSE_STATUS={
  DRAFT:"Draft",
  PUBLISHER:"Published",
};